
export const visionTranslations = {
  visionMissionValues: {
    fr: "Notre Vision, Mission et Valeurs",
    en: "Our Vision, Mission and Values"
  },
  visionText: {
    fr: "Construire le rendez-vous mensuel le plus puissant et influent de professionnels algériens expérimentés et de sa diaspora mondiale. Un cercle bienveillant où l'Algérie et ses espoirs se rencontrent chaque premier mardi pour bâtir l'avenir du pays.",
    en: "Building the most powerful and influential monthly meeting of experienced Algerian professionals and its global diaspora. A benevolent circle where Algeria and its aspirations meet every first Tuesday to build the country's future."
  },
  missionText: {
    fr: "Rassembler chaque premier mardi les professionnels algériens en action - entrepreneurs confirmés, dirigeants éprouvés, experts et investisseurs - engagés dans le développement de l'Algérie par l'innovation, la collaboration et l'action concrète.",
    en: "Gathering every first Tuesday Algeria's professionals in action - confirmed entrepreneurs, proven leaders, experts and investors - committed to Algeria's development through innovation, collaboration and concrete action."
  },
  values: {
    fr: "Valeurs",
    en: "Values"
  },
  humanExcellence: {
    fr: "Exigence humaine",
    en: "Human Excellence"
  },
  sharedTrust: {
    fr: "Confiance partagée",
    en: "Shared Trust"
  },
  generosityOfAction: {
    fr: "Générosité d'action",
    en: "Generosity of Action"
  },
  livelyCuriosity: {
    fr: "Curiosité vive",
    en: "Lively Curiosity"
  },
  worldOpeness: {
    fr: "Ouverture sur le monde",
    en: "Openness to the World"
  },
};
